
import { writable } from 'svelte/store';

export const permissaoUsuario = writable({permissoes:""
    
  });
  export const permissaoPlataforma = writable({
    
  });
  export const DadosGenericos = writable({
    
  });
  export const DadosPaginaAnterior= writable({
    
  });
  export const DadosLogin= writable({
    
  });
  export const DadosPlano= writable({
    
  });
  export const ConfirmaEmail= writable({
    
  });

  export const versaoTeste= writable(0);